
































import Chart from 'chart.js';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Word extends Vue {
  public operation: string = 'word-count';
  private paragraph: string = '';
  public count: number = 0;
  private chartContext: any;
  private chart: any;
  public rawListWords: string = '';

  mounted() {
    this.chartContext = this.$refs.frequencyChart;
  }

  toggle() {
    let config = Object.assign({}, this.chart.config);
    config.type = 'line';

    this.chart.destroy();
    this.chart = new Chart(this.chartContext, config);
  }

  calculate(operation: string, trimSpaces = false) {
    if (this.paragraph.length === 0) {
      this.count = 0;
    }

    this.calculateFrequencies();

    switch(operation) {
      case 'word-count':
        return this.paragraph.replace(/\s+/g,' ').trim().split(' ').length;
      case 'char-count':
        if (trimSpaces) {
          return this.paragraph.replace(/\s+/g, '').length;
        } else {
          return this.paragraph.length;
        }
      default:
        return 0;
    }
  }

  calculateFrequencies() {
    if (this.paragraph.length === 0) { return; }

    let wordFrequencies: { [key: string]: number; } = {};

    let words = this.paragraph.trim().split(' ');
    let spaceCount = this.paragraph.length - this.paragraph.replace(/\s+/g, '').length;
    
    words.forEach((word) => {
      if (!word) {
        return;
      }

      if (!wordFrequencies[word]) {
        wordFrequencies[word] = 0;
      }

      wordFrequencies[word]++;
    });

    wordFrequencies.space = spaceCount;

    let labels = Object.keys(wordFrequencies);
    let data = labels.map((key) => { return wordFrequencies[key] });

    let chartData = {
      type: 'bar',
      data: {
        labels,
        datasets: [
          {
            label: "Word Frequency",
            data,
            backgroundColor: [
              'rgba(54,73,93,.5)',
              'rgba(54,73,93,.5)',
              'rgba(54,73,93,.5)',
              'rgba(54,73,93,.5)',
              'rgba(54,73,93,.5)',
              'rgba(54,73,93,.5)',
              'rgba(54,73,93,.5)',
              'rgba(54,73,93,.5)'
            ],
            borderColor: [
              '#36495d',
              '#36495d',
              '#36495d',
              '#36495d',
              '#36495d',
              '#36495d',
              '#36495d',
              '#36495d',
            ],
            borderWidth: 3
          }
        ]
      },
      options: {
        responsive: true,
        lineTension: 1,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              padding: 25,
            }
          }]
        }
      },
    };

    if(this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(this.chartContext, chartData);
  }
}
